module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_111_7.af26f515.pdf";